export function onlyUnique(value, index, array) {
  return array.indexOf(value) === index;
}
